import TaggedLogger from '../../debug/tagged-logger';

const logger = new TaggedLogger('BraintreePaymentWidget', 'color:#e08031');

/**
 * BraintreePaymentWidget
 */
class BraintreePaymentWidget {
  /**
   * Init braintree.js external script and callbacks
   * @param {Object} _braintreeConfig - token and js assets
   * @param {string} source - cart|checkout|product
   * @param {Object} global - set global (for unit testing)
   */
  constructor(_braintreeConfig = {}, source = '', global = window) {
    this.global = global;
    this.init(source, _braintreeConfig);
  }

  /**
   * @param {string} source - cart|checkout|product
   * @param {Object} _braintreeConfig - config
   * @param {string} _braintreeConfig.token - token
   * @param {string} _braintreeConfig.js_client url to client SDK
   * @param {string} _braintreeConfig.js_data_collector url to data collector SDK
   */
  init(source, _braintreeConfig = {}) {
    if (source !== 'checkout') {
      return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = _braintreeConfig.js_client;
    scriptTag.onload = () => {
      this.collectData(_braintreeConfig);
    };

    const scriptTag2 = document.createElement('script');
    scriptTag2.src = _braintreeConfig.js_data_collector;

    document.body.appendChild(scriptTag);
    document.body.appendChild(scriptTag2);
  }

  /**
   * @see https://developers.braintreepayments.com/guides/client-sdk/setup/javascript/v3
   * @param {Object} _braintreeConfig - config
   * @param {string} _braintreeConfig.token - token
   * @param {string} _braintreeConfig.js_client url to client SDK
   * @param {string} _braintreeConfig.js_data_collector url to data collector SDK
   */
  collectData(_braintreeConfig = {}) {
    this.global.braintree.client.create({
      authorization: _braintreeConfig.token,
    }, (errCl, clientInstance) => {
      if (errCl) {
        logger.error(errCl.message);
        return;
      }
      this.global.braintree.dataCollector.create({
        client: clientInstance,
        kount: true,
      }, (errDc, dataCollectorInstance) => {
        if (errDc) {
          logger.error(errDc.message);
          return;
        }
        const deviceData = dataCollectorInstance.deviceData;

        const hidden = document.createElement('input');
        hidden.id = 'braintree_device_data';
        hidden.type = 'hidden';
        hidden.name = 'data[device_data]';
        hidden.value = typeof deviceData === 'string' ? deviceData : JSON.stringify(deviceData);

        let form = document.getElementById('userIndexForm');
        if (!form) {
          form = document.getElementById('userApiForm');
        }
        if (form) {
          form.appendChild(hidden);
        } else {
          logger.warn('Can not find checkout form on a page to inject device_data to');
        }
      });
    });
  }
}

export default BraintreePaymentWidget;



// WEBPACK FOOTER //
// ./Library/1.0/common/payment_widgets/widgets/BraintreePaymentWidget.js